import { Label } from '@ekkogmbh/apisdk';
import { Chip } from '@mui/material';
import { green, orange, red } from '@mui/material/colors';
import { useMemo } from 'react';

interface DeviceStatusProps {
  value: Label['status'];
}

const saturation = 400;

export default function DeviceStatus({ value }: DeviceStatusProps): React.JSX.Element {
  const backgroundColor = useMemo(() => {
    switch (value) {
      case 'GOOD':
      case 'ONLINE':
        return green[saturation];
      case 'OFFLINE':
      case 'TIMEOUT':
      case 'UNASSIGNED':
      case 'BAD':
        return red[saturation];
      default:
        return orange[saturation];
    }
  }, [value]);

  const component = useMemo(
    () => (
      <Chip
        label={value}
        style={{
          backgroundColor,
          color: 'white',
        }}
      />
    ),
    [value, backgroundColor],
  );

  return component;
}
